<section class="secondary-drawer-container">
  <button class="drawer-close-btn mat-elevation-z0" mat-mini-fab aria-label="Close" (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </button>
  <h5 class="drawer-title">Smart Recommendations</h5>
</section>
<div *ngIf="isAssetListLoading || isProcessing">
  <app-list-loader></app-list-loader>
</div>
<div class="custom-scroller recommendation-notifications">
  <ng-container *ngIf="!isAssetListLoading && !isProcessing && (assetsDetails?.assets && assetsDetails?.assets.length > 0)">
    <mat-card class="d-inline-block w-100 float-start notifications recommendation-card"
              *ngFor="let asset of assetsDetails?.assets; index as i">
      <div class="w-100 d-inline-block float-start mb-20">
        <h2 class="mb-0 font-poppins font-regular font-15 line-height-20">{{asset.displayTitle}}</h2>
        <h2 class="mb-0 font-poppins font-regular font-15 line-height-20">{{asset.propertyAddress}}</h2>
        <div class="gray-text font-12">
          <span>
            {{asset.actionPerformDate | date:'dd MMM yyyy'}} at {{
asset.actionPerformDate |
                        date:'shortTime'
            }}
          </span>
        </div>
      </div>
      <div class="mt-2 w-100 d-flex justify-content-between align-items-center">
        <div class="col-lg-6 col-md-12">
          <button class="common-button medium success mat-elevation-z0 me-2 no-min-width" mat-button mat-raised-button
                  (click)="acceptRecomandation(asset)">
            <mat-icon class="material-icons-outlined" mat-list-icon>check</mat-icon>
            Accept
          </button>
          <button class="common-button medium danger mat-elevation-z0 ms-2 no-min-width" mat-button mat-raised-button
                  (click)="rejectRecomandation(asset)">
            <mat-icon class="material-icons-outlined" mat-list-icon>close</mat-icon>
            Reject
          </button>
        </div>
        <div class="d-flex right-btn-wrapper flex-row col-lg-6 col-md-12 align-items-center justify-content-end">
          <div class="d-flex blue-icon-line pe-3 vertical-seperator col-lg-6 col-md-12 width-auto">
            <mat-icon class="material-icons-outlined" aria-hidden="false" aria-label="visibility icon">snooze</mat-icon>
            <a class="ml-2" (click)="showAssetSnoozedDrawer(asset)">Snooze</a>
          </div>
          <div class="d-flex blue-icon-line ms-3 col-lg-6 col-md-12 width-auto">
            <mat-icon class="material-icons-outlined" aria-hidden="false" aria-label="visibility icon">web_asset</mat-icon>
            <a class="ml-2 white-space-nowrap" (click)="showAssetDetailDrawer(asset)">View Asset Details</a>
          </div>
        </div>
      </div>
    </mat-card>
  </ng-container>
</div>
<div class="no-jobs-indicator d-flex flex-column align-items-center justify-contet-center text-center mt-5 pt-5"
     *ngIf="!assetsDetails || (assetsDetails?.assets && assetsDetails?.assets.length == 0)">
  <img src="../../../../assets/images/empty-box-open.png" width="100" />
  <h4 class="font-poppins font-medium mt-3">No results found.</h4>
</div>
<mat-paginator *ngIf="!isAssetListLoading && (assetsDetails?.assets && assetsDetails?.assets.length > 0)" class="mt-4 pagination" [length]="pageTotal" [pageSize]="pageSize"
               [pageIndex]="pageNumber" aria-label="Select page" [hidePageSize]="true"
               (page)="getAssetsPaginatedResult($event.pageIndex)">
</mat-paginator>

<mat-drawer-container [hasBackdrop]="true" class="custom-drawer asset-rec-drawer">
  <mat-drawer class="lg bg-light-gray" mode="over" position="end" [(opened)]="isOpenAssetDetailsDrawer" *ngIf="isOpenAssetDetailsDrawer">
    <app-view-asset-details [assetId]="selectedAssetId"
                            (acceptRecomandationEvent)="acceptRecomandationFromAssetView()"
                            (rejectRecomandationEvent)="rejectRecomandationFromAssetView()"
                            (snoozeRecomandationEvent)="snoozeRecomandationFromAssetView()"
                            (closeEvent)="closeDrawer()">
    </app-view-asset-details>
  </mat-drawer>
</mat-drawer-container>

<mat-drawer-container [hasBackdrop]="true" class="custom-drawer">
  <mat-drawer class="lg" mode="over" position="end" [(opened)]="isOpenAssetSnoozedDrawer" *ngIf="isOpenAssetSnoozedDrawer">
    <app-snooze-asset-recommendations [selectedAsset]="selectedAsset" (closeEvent)="closeDrawer()" (refreshRecomendations)="refreshRecomendation()">
    </app-snooze-asset-recommendations>
  </mat-drawer>
</mat-drawer-container> 
